import React, { useEffect } from 'react'
import PaymentsHeader from 'component/Payments/PaymentsHeader'
import PaymentsTable from 'component/Payments/PaymentsTable'
import { useAppDispatch } from 'hooks/reduxHooks'
import { clearPayment } from 'slices/payment'

const PaymentsPageLayout: React.FC = () => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		return () => {
			dispatch(clearPayment())
		}
	}, [])

	return (
		<>
			<PaymentsHeader />
			<PaymentsTable />
		</>
	)
}

export default PaymentsPageLayout
